import React, { useState } from "react";

import { Form } from "components";
import { pinResetSchema, changePhoneSchema } from "utils/formSchema";
import { useUpdatePin, useVerifyPin } from "api";
import { createPinFormList, changePinFormList } from "utils/constants";
import { useSelector } from "react-redux";
import { useUpdatePinAlt } from "api/actions/profile";

const initialFieldValues = { pin: "", confirmPin: "", password: "" };

const changePinInitialVal = {
  code: "",
};

export default function CreatePin() {
  const [updatedValue, setUpdatedValue] = useState();

  const {
    user_details: { email, displayName },
  } = useSelector((state) => state.profile);

  const [isUpdating, isUpdated, verifyEmailPin] = useVerifyPin();

  const [isUpdatingPin, isUpdatedPin, updatePIN] = useUpdatePin();

  const fieldList = createPinFormList;

  const handleVerify = (values) => {
    setUpdatedValue(values);
    verifyEmailPin({ ...values, displayName });
  };

  const handleSubmit = (values, resetForm) => {
    updatePIN({ ...values, ...updatedValue, sentEmail: true }, resetForm);
  };

  return (
    <div className="mt-4">
      <div className="grid grid-cols-1 gap-6">
        <Form
          fieldList={fieldList}
          initialFieldValues={initialFieldValues}
          buttonText="Verify"
          buttonLoading={isUpdating}
          handleSubmit={handleVerify}
          validationSchema={pinResetSchema}
          disableVisibilty={isUpdated}
          isDisabled={isUpdating}
          isDisabledFormFirstForm={isUpdated}
          // fullWidth
        />
        {isUpdated && (
          <>
            <div className="mt-6" />
            <Form
              fieldList={changePinFormList(email)}
              initialFieldValues={changePinInitialVal}
              buttonText="Save PIN"
              buttonLoading={isUpdatingPin}
              handleSubmit={handleSubmit}
              validationSchema={changePhoneSchema}
              isDisabled={isUpdatingPin}
              resetFormOnCompleted={isUpdatedPin}
              // fullWidth
            />
          </>
        )}
      </div>
    </div>
  );
}

export function CreatePinAlt() {
  const [isUpdatingPin, isUpdatedPin, updatePIN] = useUpdatePinAlt();

  const fieldList = createPinFormList;

  const handleSubmit = (values, resetForm) => {
    updatePIN(values, resetForm);
  };

  return (
    <div className="mt-4">
      <div className="grid grid-cols-1 gap-6">
        <Form
          fieldList={fieldList}
          initialFieldValues={initialFieldValues}
          buttonText="Save Pin"
          buttonLoading={isUpdatingPin}
          handleSubmit={handleSubmit}
          validationSchema={pinResetSchema}
          isDisabled={isUpdatingPin}
        />
      </div>
    </div>
  );
}
